import { Radio, RadioGroup } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FolderPermissionReadAccess } from '../../../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsField } from '../PermissionsField';

export function PermissionsReadGroup() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  return (
    <PermissionsField label={t('permissions.modifyAction.readGroup.label')}>
      <Controller
        control={control}
        name="readItems"
        render={({ field: { value, onChange } }) => {
          return (
            <RadioGroup style={{ flexDirection: 'row', gap: 4 }}>
              <Radio
                label={t('permissions.modifyAction.readGroup.options.none')}
                checked={value === FolderPermissionReadAccess.NONE}
                value={FolderPermissionReadAccess.NONE}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
              <Radio
                label={t('permissions.modifyAction.readGroup.options.full')}
                checked={value === FolderPermissionReadAccess.FULL_DETAILS}
                value={FolderPermissionReadAccess.FULL_DETAILS}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
            </RadioGroup>
          );
        }}
      />
    </PermissionsField>
  );
}
